import { createTypeElement } from './util'

const Placeholder = props => createTypeElement('Placeholder', props)

export default Placeholder
